export default "__VITE_ASSET__DeYHrx3y__"